/*
module.exports = {
  home: {
    title: '首頁',
    message: '歡迎進入中央周邊平臺',
    welcome:'歡迎您，',
    signOut:'退出登錄',
    systemSettings:'系統設置',
    changePassword:'密碼修改',
    departmentSwitch:'部門切換',
    prompt:'提示',
    outMsg:'真的要註銷登錄嗎 ?',
    errorTitle:'錯誤',
    searchMenu:'搜索菜單',
    welcomeBack: '歡迎回來',
    welcomeTitle:'歡迎',
    loginFailed:'登陸失敗',
  },
  page:{
    total:' 共 ',
    article:' 條 ',
  }
}*/
